module.exports = __webpack_public_path__ + "static/img/home2@2x.8ac24114.png";